import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'whatwg-fetch'
import 'cars_search/desktop'
import { renderReact } from 'hypernova-react'

import SearchFormContainerComponent from '../cars_search/SearchFormContainer'

export const SearchFormContainer = renderReact(
  'SearchFormContainer',
  SearchFormContainerComponent
)
